import { Injectable } from '@angular/core';
import { NetworkService } from 'src/app/core/services/network.service';
import { DataService } from './data.service';
import { ROLES } from 'src/app/shared/roleList/priorityRoleList';
import { DFOSROLES } from '../roleList/dfosRoleList';
import { DatePipe } from '@angular/common';
import { catchError, map } from 'rxjs/operators';
import { Observable, of, firstValueFrom } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { HttpClient } from '@angular/common/http';
import { ALL, OPEN_V, QTY_PIE, SELECTED_FACTORY } from 'src/app/app.contant';
import { BehaviorSubject } from 'rxjs';
import { factory } from 'src/app/features/quality-one/components/popups/select-characters/mock-constants';

@Injectable({
  providedIn: 'root'
})
export class SharedRequesterService {
  public dfosLines = [];
  public isFirstTimeAppLoading: boolean = true;
  roles: any[] = ROLES;
  userRole: any;
  ipAddress: any;
  public gaViewMode: any;
  constructor(
    private http: HttpClient,
    private networkService: NetworkService,
    private authService: MsalService,
    private dataSer: DataService,
    private datePipe: DatePipe) { }

  private alerts = new BehaviorSubject<any>(0);
  castAlerts = this.alerts.asObservable();
  changeAlert(newalert) {
    this.alerts.next(newalert);
  }

  // getClusters() {
  //   const account = this.authService.instance.getActiveAccount();
  //   const profile = account && account.idToken ? account.idToken.roles : [];
  //   const dfosRole = this.dataSer.rolePrioritySetter(profile).length ?
  //     DFOSROLES.find(item => item.toLowerCase() === this.dataSer.rolePrioritySetter(profile)[0]) :
  //     (profile ? profile[0] : null);
  //   return this.networkService.httpReq('get', 'dfos', 'collectionName/clusters?role=' + dfosRole);
  // }

  getClusters() {
    const account = this.authService.instance.getActiveAccount();
    const profile = account && account.idTokenClaims ? (account.idTokenClaims as any).roles || [] : [];
    const dfosRole = this.dataSer.rolePrioritySetter(profile).length ?
      DFOSROLES.find(item => item.toLowerCase() === this.dataSer.rolePrioritySetter(profile)[0]) :
      (profile ? profile[0] : null);
    if (!account) {
      return this.networkService.httpReq('get', 'dfos', 'GetDfosFactories', {}, false);
    } else {
      return this.networkService.httpReq('get', 'SPCAPI', 'GetDfosFactories?rolename=' + dfosRole);
    }

  }

  getFactories(selectedCluster) {
    return this.networkService.httpReq('get', 'dfos', 'collectionName/region/' + selectedCluster.clusterId + '/factories');
  }

  getFactoryOffset(factoryDtls) {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetUTCOffset', {
      timezone: factoryDtls.timeZone
    }, false);
  }


  getFactoryNamedata() {
    const f: any = this.dataSer.getStorageData(SELECTED_FACTORY);
    return {
      factoryname: f ? JSON.parse(f).factoryId : null
    };
  }

  public getMaterial(factoryId: any): Observable<any> {
    const data = { factoryId };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetMaterials', data, false)
      .pipe(map((res: any) => {
        if (res && res.materials) {
          return res.materials;
        }
        return [];
      }));
  }

  public getSupplierInfo(from?: string) {
    const factory = this.dataSer.getStorageData(SELECTED_FACTORY);
    const factoryId = factory ? JSON.parse(factory).factoryId : null;
    const data = { factoryId };
    if (from === 'process') {
      data['isQuantitative'] = '1'; // 1 -> Quantitative=1 & 0 -> Attribute
    }
    return this.networkService.httpReq('get', 'SPCAPI', 'GetSupplierInfo', data, false)
      .pipe(map((res: any) => {
        if (res && res.supplierDataInfo) {
          return res.supplierDataInfo;
        }
        return [];
      }));
  }

  public GetEIncidents(fd: any): Observable<any> {
    const factory = this.dataSer.getStorageData(SELECTED_FACTORY);
    const factoryId = factory ? JSON.parse(factory).factoryId : null;
    const StartTimeEpoch = fd.fromTime ? Math.floor((+fd.fromTime.from) / 1000) : null;
    const EndTimeEpoch = fd.fromTime ? Math.floor((+fd.fromTime.to) / 1000) : null;
    const SupplierMasterid = fd.supplier.suppliermasterid ? fd.supplier.suppliermasterid : null;
    let MaterialCode = fd.material && fd.material.materialcode ? fd.material.materialcode : null;
    MaterialCode = MaterialCode === 'All Materials' ? ALL : MaterialCode;
    const data = { factoryId, MaterialCode, SupplierMasterid, StartTimeEpoch, EndTimeEpoch };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetEIncidents', data, false)
      .pipe(map((res: any) => {
        if (!res) {
          return [];
        }
        return res.eIncidents;
      }));
  }

  public GetCharacteristicSpecification(fd: any): Observable<any> {
    const factory = this.dataSer.getStorageData(SELECTED_FACTORY);
    const factoryId = factory ? JSON.parse(factory).factoryId : null;
    const StartTimeEpoch = fd.fromTime ? Math.floor((+fd.fromTime.from) / 1000) : null;
    const EndTimeEpoch = fd.fromTime ? Math.floor((+fd.fromTime.to) / 1000) : null;
    const SupplierMasterid = fd.supplier.suppliermasterid ? fd.supplier.suppliermasterid : null;
    let MaterialCode = fd.material && fd.material.materialcode ? fd.material.materialcode : null;
    MaterialCode = MaterialCode === 'All Materials' ? ALL : MaterialCode;
    const CharacteristicMasterId = fd.character.map((c: any) => c.characteristicmasterId);
    const Type = fd.crType ? fd.crType : ALL;
    const LongTerm = fd.longTerm ? fd.longTerm : ALL;
    const Batch = fd.batch ? fd.batch.Batch : '';
    const data = { factoryId, MaterialCode, SupplierMasterid, StartTimeEpoch, EndTimeEpoch, CharacteristicMasterId, Type, LongTerm, Batch };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetCharacteristicSpecification', data, false)
      .pipe(map((res: any) => {
        if (!res || res.specification.length === 0) {
          return JSON.parse(JSON.stringify(QTY_PIE));
        }
        const ob: any = JSON.parse(JSON.stringify(QTY_PIE));
        res.specification.forEach((e: any) => {
          const k: string = e.inSpec ? e.inSpec : OPEN_V;
          ob[k] = e.count;
        });
        return ob;
      }));
  }

  public GetCharacteresticPkPpk(fd: any): Observable<any> {
    const factory = this.dataSer.getStorageData(SELECTED_FACTORY);
    const factoryId = factory ? JSON.parse(factory).factoryId : null;
    const StartTimeEpoch = fd.fromTime ? Math.floor((+fd.fromTime.from) / 1000) : null;
    const EndTimeEpoch = fd.fromTime ? Math.floor((+fd.fromTime.to) / 1000) : null;
    const SupplierMasterId = fd.supplier.suppliermasterid ? fd.supplier.suppliermasterid : null;
    let MaterialCode = fd.material && fd.material.materialcode ? fd.material.materialcode : null;
    MaterialCode = MaterialCode === 'All Materials' ? ALL : MaterialCode;
    const CharacteristicMasterId = fd.character.map((c: any) => c.characteristicmasterId);
    const Type = fd.crType ? fd.crType : ALL;
    const LongTerm = fd.longTerm ? fd.longTerm : ALL;
    const Batch = fd.batch ? fd.batch.Batch : '';
    const data = { factoryId, MaterialCode, SupplierMasterId, StartTimeEpoch, EndTimeEpoch, CharacteristicMasterId, Type, LongTerm, Batch };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetCharacteresticPkPpk', data, false)
      .pipe(map((res: any) => {
        if (res && res.characteristics.length > 0) {
          return res.characteristics;
        }
        return [];
      }));
  }

  //  new dashboard
  public getQyalityOneDashboardData(fd: any, time: any, src = ''): Observable<any> {
    const factory = this.dataSer.getStorageData(SELECTED_FACTORY);
    const factoryId = factory ? JSON.parse(factory).factoryId : null;
    const StartTimeEpoch = time ? Math.floor((+time.from) / 1000) : null;
    const EndTimeEpoch = time ? Math.floor((+time.to) / 1000) : null;
    const SupplierMasterId = fd.supplier === ALL ? ALL : fd.supplier && fd.supplier.suppliermasterid ? fd.supplier.suppliermasterid : null;
    let MaterialCode = fd.material === ALL ? ALL : fd.material && fd.material.materialcode ? fd.material.materialcode : null;
    MaterialCode = MaterialCode === 'All Materials' ? ALL : MaterialCode;
    const data = { factoryId, MaterialCode, SupplierMasterId, StartTimeEpoch, EndTimeEpoch };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetQualityOneDashboardData', data, false)
      .pipe(map((res: any) => {
        if (res && res.length > 0) {
          return res;
        }
        return [];
      }));
  }

  public getDashBoardSpecifications(supplier: any, material: any, type: boolean, time: any): Observable<any> {
    const factory = this.dataSer.getStorageData(SELECTED_FACTORY);
    const factoryId = factory ? JSON.parse(factory).factoryId : null;
    const StartTimeEpoch = time ? Math.floor((+time.from) / 1000) : null;
    const EndTimeEpoch = time ? Math.floor((+time.to) / 1000) : null;
    const SupplierMasterid = supplier === ALL ? ALL : supplier && supplier.suppliermasterid ? supplier.suppliermasterid : null;
    let MaterialCode = material === ALL ? ALL : supplier && material.materialcode ? material.materialcode : null;
    MaterialCode = MaterialCode === 'All Materials' ? ALL : MaterialCode;
    const IsQuantitative: boolean = type;
    const data = { factoryId, MaterialCode, SupplierMasterid, StartTimeEpoch, EndTimeEpoch, IsQuantitative };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetDashBoardSpecifications', data, false)
      .pipe(map((res: any) => {
        if (res && res.dashBoardSpecifications && res.dashBoardSpecifications.length > 0) {
          return res.dashBoardSpecifications;
        }
        return [];
      }));
  }

  getLines(chartsType = null, factoryDtls = null, dbconnect = 'No') {
    let data: any;
    data = {
      factoryname: factoryDtls ? factoryDtls.factoryId : (this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null),
      type: chartsType,
      ForceWriteDB: dbconnect
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetLines', data, false);
  }

  getMachinesUnderLine(line, type = null, factoryDtls = null, dbconnect = 'No') {
    let data: any;
    if (line === 'ALL') {
      data = {
        factoryname: factoryDtls ? factoryDtls.factoryId : (this.dataSer.getStorageData('selectedFactory') ?
          JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null),
        ForceWriteDB: dbconnect

      };
    } else {
      data = {
        factoryname: factoryDtls ? factoryDtls.factoryId : (this.dataSer.getStorageData('selectedFactory') ?
          JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null),
        lineid: (line && line.id) ? line.id : '',
        ForceWriteDB: dbconnect

      };
    }
    data.type = type ? type : null;
    return this.networkService.httpReq('get', 'SPCAPI', 'GetMachines', data, false);
  }

  public getSKUs(param?: any, ForceWriteDB: string = 'No') {
    const data: any = param ? param : {};
    data.ForceWriteDB = ForceWriteDB;
    data.factoryname = this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null;
    return this.networkService.httpReq('get', 'SPCAPI', 'GetSkus', data, false);
  }

  public GetSkuFormat() {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetSkuFormat', this.getFactoryNamedata(), false);
  }

  getParametersUnderMachine(machineDtls, showOnlyBatchParam?, factoryDtls = null) {
    let batchFilter = null;
    // 3 cases for showOnlyBatchParam - true means only batch, false means only continous, otherwise show all

    if (showOnlyBatchParam === true) {
      batchFilter = 'yes';
    } else if (showOnlyBatchParam === false) {
      batchFilter = 'no';
    }

    const data: any = {
      machineid: machineDtls ? machineDtls.id : null,
      factoryname: factoryDtls ? factoryDtls.factoryId : (this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null),
    };

    if (batchFilter) {
      data.batch = batchFilter;
    }

    return this.networkService.httpReq('get', 'SPCAPI', 'GetParameters', data, false);
  }

  getParametersUnderMachineMultiple(machineDtls, showOnlyBatchParam?, isdownloadType?, egaType?) {
    let batchFilter = null;
    const machineList: any = [];
    // 3 cases for showOnlyBatchParam - true means only batch, false means only continous, otherwise show all
    let data;
    data = {
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
    };
    if (showOnlyBatchParam === true) {
      batchFilter = 'yes';
    } else if (showOnlyBatchParam === false) {
      batchFilter = 'no';
    }
    for (const value of machineDtls) {
      if (value && value.id) {
        machineList.push(value.id);
      }
    }
    data.machineid = machineList;

    if (batchFilter) {
      data.batch = isdownloadType ? (showOnlyBatchParam ? 'no' : 'yes') : batchFilter;
    }
    data.type = egaType ? egaType : undefined;

    return this.networkService.httpReq('get', 'SPCAPI', 'GetParameters', data, false);
  }

  getSKUsWithinTimeRange(lineID, periodDtls, custDate?, factoryDtls = null) {
    const data: any = {
      factoryId: factoryDtls ? factoryDtls.factoryId : (this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null),
      LineId: lineID === 'ALL' ? '' : lineID,
      StartTimeEpoch: 0,
      EndTimeEpoch: 0
    };
    if (periodDtls && periodDtls.code === 'hour') {
      const now = new Date();
      data.EndTimeEpoch = Math.floor((+now) / 1000);
      if (periodDtls.value === 1) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 1)) / 1000);
      } else if (periodDtls.value === 2) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 2)) / 1000);
      } else if (periodDtls.value === 4) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 4)) / 1000);
      } else if (periodDtls.value === 8) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 8)) / 1000);
      }
    } else if (periodDtls && (periodDtls.code === 'custom' || periodDtls.code === 'comparison-custom')) {
      data.StartTimeEpoch = Math.floor(+custDate.from / 1000);
      data.EndTimeEpoch = Math.floor(+custDate.to / 1000) + 59;
    }
    return this.networkService.httpReq('get', 'SPCAPI', 'GetSkuRunListBasedOnTimeRange', data, false);
  }
  getSKUsWithinTimeRangeManual(lineID, periodDtls, epoch, factoryDtls = null) {
    const data: any = {
      factoryId: factoryDtls ? factoryDtls.factoryId : (this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null),
      LineId: lineID === 'ALL' ? '' : lineID,
      StartTimeEpoch: epoch,
      EndTimeEpoch: epoch
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetSkuRunListBasedOnTimeRange', data, false);
  }

  getManualSKURunListWithinTimeRange(lineID, epoch, skuid, factoryDtls = null) {
    const data: any = {
      factoryId: factoryDtls ? factoryDtls.factoryId : (this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null),
      LineId: lineID === 'ALL' ? '' : lineID,
      StartTimeEpoch: epoch,
      EndTimeEpoch: epoch,
      skuid: skuid
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetManualDataSkuRunListBasedOnTimeRange', data, false);

  }

  /* istanbul ignore next */
  public getManualSensorData(form: any, custDate?: any): any {
    const f = this.dataSer.getStorageData('selectedFactory');
    const factoryId = f ? JSON.parse(f).factoryId : null;
    const data: any = {
      factoryId,
      LineId: form.line.id,
      type: form.type,
      parameterId: form.parametersFilter.map((p: any) => p.id),
      StartTimeEpoch: 0,
      EndTimeEpoch: 0
    };
    const periodDtls = form.period;
    if (periodDtls && periodDtls.code === 'hour') {
      const now = new Date();
      data.EndTimeEpoch = Math.floor((+now) / 1000);
      if (periodDtls.value === 1) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 1)) / 1000);
      } else if (periodDtls.value === 2) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 2)) / 1000);
      } else if (periodDtls.value === 4) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 4)) / 1000);
      } else if (periodDtls.value === 8) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 8)) / 1000);
      }
    } else if (periodDtls && (periodDtls.code === 'custom' || periodDtls.code === 'comparison-custom')) {
      data.StartTimeEpoch = Math.floor(+custDate.from / 1000);
      data.EndTimeEpoch = Math.floor(+custDate.to / 1000);
    }
    return this.networkService.httpReq('get', 'SPCAPI', 'GetManualSensorData', data, false).pipe(
      map((res: any) => {
        if (res && res.manualSensorDataInfo && res.manualSensorDataInfo.length) {
          res.manualSensorDataInfo.forEach((el: any) => {
            el.time = el.TS;
            el.Value = parseFloat(el.Value);
          });
          return res.manualSensorDataInfo;
        }
        return [];
      })
    );
  }

  /* istanbul ignore next */
  public deleteManualData(form: any, param: any, reasonfordelete: string, custDate?: any): any {
    const f = this.dataSer.getStorageData('selectedFactory');
    const factoryId = f ? JSON.parse(f).factoryId : null;
    const data: any = {
      factoryId,
      LineId: form.line.id,
      type: form.type,
      reasonfordelete,
      parameterId: param && param.ids ? param.ids.toString() : '',
      tsEpoch: param && param.tsEpoch ? param.tsEpoch.toString() : '',
      startTimeEpoch: 0,
      endTimeEpoch: 0
    };
    const periodDtls = form.period;
    if (periodDtls && periodDtls.code === 'hour') {
      const now = new Date();
      data.endTimeEpoch = Math.floor((+now) / 1000);
      if (periodDtls.value === 1) {
        data.startTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 1)) / 1000);
      } else if (periodDtls.value === 2) {
        data.startTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 2)) / 1000);
      } else if (periodDtls.value === 4) {
        data.startTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 4)) / 1000);
      } else if (periodDtls.value === 8) {
        data.startTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 8)) / 1000);
      }
    } else if (periodDtls && (periodDtls.code === 'custom' || periodDtls.code === 'comparison-custom')) {
      data.startTimeEpoch = Math.floor(+custDate.from / 1000);
      data.endTimeEpoch = Math.floor(+custDate.to / 1000);
    }
    return this.networkService.httpReq('delete', 'SPCAPI', 'DeleteManualData', data, false);
  }

  getSpecificParametersUnderMachine(machineDtls, type = null) {
    const factory = this.dataSer.getStorageData('selectedFactory');
    const data: any = {
      machineid: machineDtls ? machineDtls.machineid : '',
      factoryname: factory ? JSON.parse(factory).factoryId : null,
      paramName: machineDtls ? machineDtls.parametername : ''
    };
    if (type && type !== null) {
      data.type = type ? 'yes' : 'no';
    }
    return this.networkService.httpReq('get', 'SPCAPI', 'GetParameters', data, false);
  }

  setUslLslRedZone(uiThemeData, themeId?: any) {
    const account = this.authService.instance.getActiveAccount();
    const profile = account ? account : [];
    const userInfo: any = profile;
    const data = {
      // emailId: userInfo.username.toLowerCase(),
      settings: [
        { key: 'enableuslsl', value: uiThemeData.value.usl_lsl },
        { key: 'enableredzone', value: uiThemeData.value.redZone }
      ],
      region: uiThemeData.value.cluster.clusterId,
      factoryname: uiThemeData.value.factory.factoryId,
      id: themeId ? themeId : undefined
    };
    return this.networkService.httpReq('post', 'SPCAPI', 'AddUITheme', data, false);
  }

  getUslLslRedZone(formDtls?: any) {
    // const account = this.authService.instance.getActiveAccount();
    // const userInfo: any = account ? account : {};
    const redZoneFilter = sessionStorage.getItem('redZoneFilter');
    const usl_lsl = sessionStorage.getItem('usl_lsl');
    const data = {
      EnableRedZone: redZoneFilter ? JSON.parse(redZoneFilter) : false,
      EnableUslLsl: usl_lsl ? JSON.parse(usl_lsl) : true,
      // emailId: userInfo.username,
      cluster: formDtls ? formDtls.value.cluster.clusterId : null,
      factoryname: formDtls ? formDtls.value.factory.factoryId : null
    };
    // const url = 'GetUITheme?emailid=' + data.emailId + '&factoryname=' + data.factoryname + '&region=' + data.cluster;
    const url = 'GetUITheme?factoryname=' + data.factoryname + '&region=' + data.cluster;
    return this.networkService.httpReq('get', 'SPCAPI', url);
  }

  getFactoriesGA(selectedCluster) {
    return this.networkService.httpReq('get', 'dfos', 'collectionName/region/' + selectedCluster.clusterId + '/factories');
  }

  getFactoryNamedataGA(factoryIDGA) {
    return {
      factoryname: factoryIDGA ?
        factoryIDGA.factoryId : null,
    };
  }
  getLinesGA(factoryIDGA) {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetLines', this.getFactoryNamedataGA(factoryIDGA), false);
  }

  getMachinesUnderLineGA(line, factoryIDGA) {
    let data: any;
    if (line === 'ALL') {
      data = {
        factoryname: factoryIDGA ?
          factoryIDGA.factoryId : null,
      };
    } else {
      data = {
        factoryname: factoryIDGA ?
          factoryIDGA.factoryId : null,
        lineid: (line && line.id) ? line.id : ''
      };
    }
    return this.networkService.httpReq('get', 'SPCAPI', 'GetMachines', data, false);
  }

  getParametersUnderMachineGA(factoryIDGA, machineDtls, showOnlyBatchParam?) {
    let batchFilter = null;

    // 3 cases for showOnlyBatchParam - true means only batch, false means only continous, otherwise show all

    if (showOnlyBatchParam === true) {
      batchFilter = 'yes';
    } else if (showOnlyBatchParam === false) {
      batchFilter = 'no';
    }

    const data: any = {
      machineid: machineDtls.id,
      factoryname: factoryIDGA ?
        factoryIDGA.factoryId : null,
    };

    if (batchFilter) {
      data.batch = batchFilter;
    }

    return this.networkService.httpReq('get', 'SPCAPI', 'GetParameters', data, false);
  }

  getSKUsWithinTimeRangeGA(factoryIDGA, lineId, periodDetails, customDate?) {
    const data: any = {
      factoryId: factoryIDGA ?
        factoryIDGA.factoryId : null,
      StartTimeEpoch: 0,
      EndTimeEpoch: 0,
      LineId: lineId === 'ALL' ? '' : lineId

    };
    if (periodDetails.code === 'hour') {
      const now = new Date();
      data.EndTimeEpoch = Math.floor((+now) / 1000);
      if (periodDetails.value === 2) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 2)) / 1000);
      } else if (periodDetails.value === 1) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 1)) / 1000);
      } else if (periodDetails.value === 4) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 4)) / 1000);
      } else if (periodDetails.value === 8) {
        data.StartTimeEpoch = Math.floor((+now - (1000 * 60 * 60 * 8)) / 1000);
      }
    } else if (periodDetails.code === 'custom') {
      // custom
      data.StartTimeEpoch = Math.floor(+customDate.from / 1000);
      data.EndTimeEpoch = Math.floor(+customDate.to / 1000);
    }
    return this.networkService.httpReq('get', 'SPCAPI', 'GetSkuRunListBasedOnTimeRange', data, false);
  }

  getEgaTileData(egaData: any) {
    let data: any;
    let offset = sessionStorage.getItem('factoryOffset') ? JSON.parse(sessionStorage.getItem('factoryOffset')) : 0;
    const selectedMachines = Array.isArray(egaData.machine)
      ? egaData.machine.filter((machineId: string) => !!machineId)
      : egaData.machine
        ? [egaData.machine]
        : [];
    data = {
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      offset: offset,
      startdate: offset > 19800000 ? egaData.convertedFrom + 86400 : egaData.convertedFrom, // if offset more that 5:30 gmt then add extra day else same (86400 - 1 day)
      enddate: offset > 19800000 ? egaData.convertedTo + 86400 + 86398 : egaData.convertedTo + 86398 // // if offset more that 5:30 gmt then add extra day else same
    };
    //  if (type === 'tile1') {
    data.lineid = egaData.line ? egaData.line : 'ALL';
    data.machineid = selectedMachines.length === 0 || selectedMachines.includes('ALL')
      ? 'ALL'
      : selectedMachines.join(',');
    data.skuid = egaData.sku ? egaData.sku : 'ALL';
    //  }
    const urlType = 'GetGADashboard';
    return this.networkService.httpReq('get', 'SPCAPI', urlType, data, false);
  }

  saveGAParameter(formData: any) {
    const data: any = {
      factoryName: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      region: this.dataSer.getStorageData('selectedCluster') ?
        JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null,
      lineid: formData.line.id,
      linename: formData.line.linename,
      machineid: formData.machine.id,
      machinename: formData.machine.machinename,
      parameterid: formData.parameter.id,
      parametername: formData.parameter.parametername,
      skuid: formData.sku.skuid,
      skuname: formData.sku.skuname,
      unit: formData && formData.units ? formData.units : '',
      conversionfactor: formData.conversionfactor,
      gauom: formData && formData.gauom ? formData.gauom.label : '',
      offset: sessionStorage.getItem('factoryOffset') ? JSON.parse(sessionStorage.getItem('factoryOffset')) : 0
    };
    const cost: any = [];
    formData.costArray.forEach(costItem => {
      const egaData = {
        currency: formData && formData.cost ? formData.cost.label : '',
        skuid: formData.sku.skuid,
        skuname: formData.sku.skuname,
        startdate: costItem.covertedCostStartTime,
        enddate: costItem.covertedCostEndTime === 0 ? costItem.covertedCostEndTime :
          costItem.covertedCostEndTime + 86398,
        costvalue: costItem.costValue
      };
      cost.push(egaData);
    });
    // const ega: any = [];
    // formData.egaArray.forEach(egaItem => {
    //   const egaData = {
    //     currency: formData.cost.label,
    //     skuid: formData.sku.skuid,
    //     skuname: formData.sku.skuname,
    //     startdate: egaItem.covertedEgaStartTime,
    //     enddate: egaItem.covertedEgaEndTime === 0 ? egaItem.covertedEgaEndTime :
    //       egaItem.covertedEgaEndTime + 86398,
    //     targetGA: egaItem.egaValue
    //   };
    //   ega.push(egaData);
    // });
    data.Cost = cost;
    // data.tGA = ega;

    return this.networkService.httpReq('post', 'SPCAPI', 'SaveGAParameter', data, false);
  }

  getGAParameters() {
    const data = {
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      offset: sessionStorage.getItem('factoryOffset') ? JSON.parse(sessionStorage.getItem('factoryOffset')) : 0
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetGAParameters', data, false);
  }

  deleteGAParameters(selectedParameter: any, skuId: any) {
    const data = {
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      id: selectedParameter,
      skuid: skuId
    };
    return this.networkService.httpReq('delete', 'SPCAPI', 'DeleteGAParameters', data, false);
  }

  //  new dashboard
  /* istanbul ignore next */
  getDashboardData(filterData: any, kpi: any, criticality: any, customTimeDtls: any) {
    const data: any = {
      factoryId: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      SkuId: (filterData && filterData.sku && filterData.sku.skuId) ? filterData.sku.skuId : ''
    };

    data.CpData = kpi;
    if (criticality !== null) {
      data.criticality = criticality;
    }
    let endURl;

    if (filterData.period.value === 'last-45days') {
      filterData.period.code = 'custom';
      data.IsHistorical = false;
    } else if (filterData.period.value === 'custom') {
      data.IsHistorical = true;
    }

    if (filterData.period.code === 'custom') {
      if (filterData.line !== 'ALL') {
        data.LineId = filterData.line;
      }
      data.StartTimeEpoch = (filterData && filterData.sku && filterData.sku.startTimeEpoch) ? filterData.sku.startTimeEpoch : Math.floor((+customTimeDtls.from) / 1000);
      data.EndTimeEpoch = (filterData && filterData.sku && filterData.sku.endTimeEpoch) ? filterData.sku.endTimeEpoch : Math.floor((+customTimeDtls.to) / 1000);
      endURl = 'GetHistoricDashBoardData';
    } else {
      data.LineId = filterData.line;
      data.HourLimit = filterData.period.value;
      endURl = 'GetDashBoardData';
    }
    return this.networkService.httpReq('get', 'SPCAPI', endURl, data, false);
  }

  // user detail analyticts
  setStartTimer() {
    sessionStorage.setItem('startTimer', JSON.stringify(+new Date()));
  }

  // getIPAddress() {
  //   this.http.get("https://api.ipify.org/?format=json").subscribe((res: any) => {
  //     this.ipAddress = res.ip;
  //   });
  // }

  userAnalytics(userDtls: any) {

    //  let Ipadress = this.getIPAddress();
    const account = this.authService.instance.getActiveAccount();
    const profile: any = account ? account : null;
    const role = profile.idToken ? profile.idToken : null;
    const profilerole = account && account.idTokenClaims ? (account.idTokenClaims as any).roles || [] : [];
    const timer: string = sessionStorage.getItem('startTimer');
    const cluster: string = this.dataSer.getStorageData('selectedCluster');
    const factory: string = this.dataSer.getStorageData('selectedFactory');
    if (profile) {
      const data = {
        ApplicationName: 'SPC',
        ScreenName: userDtls.screenName,
        UserEmailId: profile.username ? profile.username : null,
        UserCountry: profile.idToken && profile.idToken.ctry ? profile.idToken.ctry : 'GB',
        UserIPAddress: '0.0.0.0',
        UserName: profile.name ? profile.name : null,
        UserWorkLocation: profile.idToken && profile.idToken.city ? profile.idToken.city : null,
        UserRole: this.dataSer.rolePrioritySetter(profilerole).length ?
          DFOSROLES.find(item => item.toLowerCase() === this.dataSer.rolePrioritySetter(profilerole)[0]) :
          (role ? role.roles[0] : null),
        StartTime: timer ? this.datePipe.transform(JSON.parse(timer), 'MMM d, y, HH:mm:ss') : null,
        EndTime: this.datePipe.transform(+new Date(), 'MMM d, y, HH:mm:ss'),
        VisitedCluster: cluster ? JSON.parse(cluster).name : null,
        VisitedFactory: factory ? JSON.parse(factory).name : null
      };
      return firstValueFrom(this.networkService.httpReq('post', 'NGTWAPI', 'insertusage', data, false, false));
    }
  }




  getParametersAll() {
    const data: any = {
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetParameters', data, false);
  }

  getScatterPlotDataPoints(param, selCustmDate, lastDay, lastFrom, lastTo) {
    const data: any = {
      IndependentParameter: param.IndependentParameter,
      DependentParameter: param.DependentParameter,
      startTime: lastDay ? Math.floor((+lastFrom) / 1000) + 1 : Math.floor((+selCustmDate.convertedFrom) / 1000),
      endTime: lastDay ? Math.floor((+lastTo) / 1000) + 86399 : Math.floor((+selCustmDate.convertedTo) / 1000),
      lastOneDay: lastDay
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetScatterPlotDataPoints', data, false);
  }

  GetCorrelationHeatMatrix(listofIds) {
    const data: any = { listofIds };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetCorrelationHeatMatrix', data, false);
  }

  GetPowerBiReportUrl(ReportType: string) {
    const data: any = {

      ReportType: ReportType

    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetPowerBiReportUrl', data, false);
  }

  public getGaReports(payload: any) {
    const factory = this.dataSer.getStorageData('selectedFactory');
    const factoryname = factory ? JSON.parse(factory).factoryId : null;

    const data: any = { factoryname, ...payload };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetGaReport', data);
  }

  GetTempSensorDataCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetTempSensorDataCount', data, false);
  }

  GetSensorDataValue() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetSensorDataValue', data, false);
  }

  GetParameterDailyCpCpkReportCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetParameterDailyCpCpkReportCount', data, false);

  }

  GetExecuteAlertJobCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetExecuteAlertJobCount', data, false);
  }

  GetExecuteSetSkuTagBatchJobCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetExecuteSetSkuTagBatchJobCount', data, false);
  }

  GetExecuteInsertSkuTagBatchCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetExecuteInsertSkuTagBatchCount', data, false);
  }

  GetExecuteDashboardBatchCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetExecuteDashboardBatchCount', data, false);
  }

  GetExecuteTriggerEmailsAndSmsCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetExecuteTriggerEmailsAndSmsCount', data, false);
  }

  GetExecuteSkuRunBatchCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetExecuteSkuRunBatchCount', data, false);
  }

  GetExecuteDfosSkuBatchCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetExecuteDfosSkuBatchCount', data, false);
  }

  GetExecuteDfosLineBatchCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetExecuteDfosLineBatchCount', data, false);
  }

  GetExecuteGiveawayCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetExecuteGiveawayCount', data, false);
  }

  GetExecuteGASkuRunRecalculateCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetExecuteGASkuRunRecalculateCount', data, false);
  }
  GetSkuProductionRunCount() {
    const data: any = {
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetSkuProductionRunCount', data, false);
  }

  GetAlertNotificationList(req, allLines, customTimeDtls, isheader) {
    let factoryname = this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null;

    const data: any = {
      "factoryid": factoryname,
      "lineids": [allLines],
      "machineids": req.machine.map((item) => { return item.id }).join(',').split(','),
      "parameterids": req.parametersFilter.map((item) => { return item.id }).join(',').split(','),
      "violationtype": req.violationTypeFilter.map((item) => { return item.value }).join(',').split(','),

    };
    if (req.period.code === 'custom') {
      data.StartTimeEpoch = Math.floor(+customTimeDtls.from / 1000);
      data.EndTimeEpoch = Math.floor(+customTimeDtls.to / 1000) + 59;
      //  data.hourlimit = 0;
    } else {
      data.hourlimit = req.period.value;
    }
    let api = isheader ? 'gettotalalertscount' : 'GetAlertNotificationList';
    let type = isheader ? 'SPCAPICI' : 'SPCAPI'
    return this.networkService.httpReq('post', type, api, data, false, false);
  }

  AckEmailAlerts(req, ids) {
    const data = [];
    ids.forEach(e => {
      data.push({
        "emailNotificationId": e.emailNotificationId,
        "comments": req.description
      })
    });

    return this.networkService.httpReq('post', 'SPCAPI', 'AckEmailAlerts', data, false);
  }

  getusecaselist() {
    let factoryId = this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null;
    const data = { factoryId: factoryId };
    return this.networkService.httpReq('get', 'SPCAPICI', 'getusecaselist', data, false);

  }


  GetCimAlertNotificationList(req, usecaseList, customTimeDtls) {
    let factoryname = this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null;

    const data: any = {
      // "usecaseids": ["1125525491000016899", "1125541600198066177", "1125735683503915018"],
      "usecaseids": req.useCase.map((item) => { return item.useCaseId }).join(',').split(','),
      // "alerttype": "ThresholdBreach",
      "factoryId": factoryname
    };



    if (req.period.code === 'custom') {
      data.StartTimeEpoch = Math.floor(+customTimeDtls.from / 1000);
      data.EndTimeEpoch = Math.floor(+customTimeDtls.to / 1000) + 59;
      //  data.hourlimit = 0;
    } else {
      data.hourlimit = req.period.value;
    }
    return this.networkService.httpReq('post', 'SPCAPICI', 'getcimalertnotification', data, false, false);
  }


  CiAckEmailAlerts(req, ids) {
    const data = [];
    ids.forEach(e => {
      data.push({
        "CimAlertNotficationId": e.cimAlertNotficationId,
        "Comments": req.description
      })
    });

    return this.networkService.httpReq('put', 'SPCAPICI', 'updatecimalertacknowledgement', data, false);
  }
}
